var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLength = function SvgLength(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B3F44",
    d: "M4.667 18q-.824 0-1.413-.587A1.93 1.93 0 0 1 2.667 16V8q0-.824.587-1.412A1.93 1.93 0 0 1 4.667 6h16q.825 0 1.412.588.588.587.588 1.412v8q0 .824-.588 1.413a1.93 1.93 0 0 1-1.412.587zm0-2h16V8h-3v4h-2V8h-2v4h-2V8h-2v4h-2V8h-3z"
  })));
};
export default SvgLength;